import React from 'react';
import PropTypes from 'prop-types';

export default class SearchForm extends React.Component {

    handleQueryChange = (event) => {
        this.props.onQueryChange(event.target.value);
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onSubmit();
    };

    render() {
        let formClassNames = 'widget--search widget--search--small widget--search--blue f-right max-width--300';
        let inputClassName = 'widget--search__input';
        if (this.props.isLargeLayout) {
            formClassNames = 'widget--search widget--search--shadow widget--search--blue margin--50--top margin--30--bot';
            inputClassName = 'widget--search__input text--center';
        }
        return (
            <form onSubmit={this.handleSubmit} className={formClassNames}>
                <label htmlFor="query" className="widget--search__label">
                    <span className="u-vis-hide">Search for a member</span>
                    <input
                        name="query"
                        id="query"
                        type="text"
                        value={this.props.actualSearch != '' ? this.props.actualSearch : this.props.query}
                        placeholder="Search for a member"
                        className={inputClassName}
                        tabIndex="2"
                        autoComplete="off"
                        onChange={this.handleQueryChange}/>
                </label>
                <button className="widget--search__btn" type="submit">
                    <img src="/img/icon-search--white.svg" alt="" className="icon" />
                    <span className="u-vis-hide">Click here to search</span>
                </button>
            </form>
        )
    }
}

SearchForm.propTypes = {
    isLargeLayout: PropTypes.bool,
    query: PropTypes.string,
    actualSearch: PropTypes.string,
    onQueryChange: PropTypes.func,
    onSubmit: PropTypes.func
};
